import React from 'react';
import { Calendar, ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

const News = () => {
  const { t, language } = useLanguage();

  const newsItems = [
    {
      title: language === 'en' ? 'ALMAD obtains its approval as SAUDI ARAMCO and SABIC Vendor' : 'ALMAD تحصل على الموافقة كمورد لأرامكو السعودية وسابك',
      date: language === 'en' ? '08-10-2025' : '08-10-2025',
      description: language === 'en' ? 'ALMAD Contracting proudly announces its approval as an authorized vendor for Saudi Aramco and SABIC, marking a significant milestone in our journey.' : 'تعلن شركة المعد للمقاولات بفخر عن حصولها على الموافقة كمورد معتمد لأرامكو السعودية وسابك، مما يمثل علامة فارقة مهمة في مسيرتنا.',
      image: '/assets/images/oil-gas-petrochemical.jpg'
    },
    {
      title: language === 'en' ? 'ALMAD starts its construction works for NWC Alkawthar Water Distribution Project' : 'ALMAD تبدأ أعمال البناء لمشروع توزيع المياه الكوثر التابع للشركة الوطنية للمياه',
      date: language === 'en' ? '15-06-2025' : '15-06-2025',
      description: language === 'en' ? 'Successfully commenced construction works for the National Water Company Alkawthar Water Distribution Project, delivering critical infrastructure for the Kingdom.' : 'بدأت بنجاح أعمال البناء لمشروع توزيع المياه الكوثر التابع للشركة الوطنية للمياه، لتقديم بنية تحتية حيوية للمملكة.',
      image: '/assets/images/alkawthar-construction.jpg'
    },
    {
      title: language === 'en' ? 'ALMAD got its approval as vendor for NATIONAL WATER COMPANY' : 'ALMAD تحصل على الموافقة كمورد للشركة الوطنية للمياه',
      date: language === 'en' ? '01-05-2025' : '01-05-2025',
      description: language === 'en' ? 'ALMAD Contracting receives official approval as a certified vendor for the National Water Company, expanding our capabilities in water infrastructure projects.' : 'تحصل شركة المعد للمقاولات على الموافقة الرسمية كمورد معتمد للشركة الوطنية للمياه، مما يوسع قدراتنا في مشاريع البنية التحتية للمياه.',
      image: '/assets/images/nwc-logo.jpg'
    },
  ];

  return (
    <div className="min-h-screen pt-24 pb-20">
      {/* Hero */}
      <section className="bg-[#141F48] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{t('newsTitle')}</h1>
          <p className="text-xl text-[#D3BC8D] font-medium">{t('newsSubtitle')}</p>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {newsItems.map((item, index) => (
              <Card key={index} className="group overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-[#141F48]/40" />
                </div>
                <CardContent className="p-6">
                  <div className="flex items-center space-x-2 text-[#D3BC8D] text-sm mb-3">
                    <Calendar className="w-4 h-4" />
                    <span>{item.date}</span>
                  </div>
                  <h3 className="text-xl font-bold text-[#141F48] mb-3 line-clamp-2">{item.title}</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">{item.description}</p>
                  <Button variant="link" className="text-[#D3BC8D] hover:text-[#141F48] p-0">
                    {t('readMore')}
                    <ArrowRight className="ml-2 w-4 h-4" />
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default News;